var NETWORK_RESOURCES = 'networkResources';

/**
 * Loads name environment for the current request.
 */
var NETWORK_RESOURCES_DEPLOYMENT_INFO_LOADED = "".concat(NETWORK_RESOURCES, "/deploymentInfoLoaded");
export {
// eslint-disable-next-line import/prefer-default-export
NETWORK_RESOURCES_DEPLOYMENT_INFO_LOADED };